import React, { useState } from "react";
import PropTypes from "prop-types";
import PrimaryLink from "../../elements/primary-link";
import "./style.scss";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import Modal from "../../components/Modal";
import useApiContent from "../../hooks/useApiContent";
import PrimaryButton from "../../elements/primary-button";
import config from "../../temp/config";

const MembershipIncludedInPlan = ({ includedData }) => {
  const [showReleaseNotesModal, setShowReleaseNotesModal] = useState();
  const releaseNotesFields = includedData?.releaseNotesLink?.fields || {};
  const [showCarWarrantyModal, setShowCarWarrantyModalModal] = useState();
  const carWarrantyFields = includedData?.carWarrantyLink?.fields || {};
  /*
    defaults to en-US and engine variant A (HEV)
    using string replace on fields language mapping because url param contains - and mapping _
    TODO: Pass engine variant from car details
  */
  const {
    apiLanguageMapping: { fields },
    language
  } = includedData;
  const BASE_URL = config.webSettings.apiHostTopicPack;

  /*
  defaults to en-US and engine variant A (HEV)
  using string replace on fields language mapping because url param contains - and mapping _
  
  TODO: Pass engine variant from car details and pass base url for different env
  */
  const carWarranty = useApiContent({
    baseUrl: BASE_URL,
    topicId: "topic:Detailed_Warranty_Information",
    lang: fields[language.replace("-", "_").toLowerCase()]?.value,
    variant: "A"
  });
  const releaseNotes = useApiContent({
    baseUrl: BASE_URL,
    topicId: "topic:Release_notes",
    lang: fields[language.replace("-", "_").toLowerCase()]?.value,
    variant: "A"
  });

  return (
    <div className="membership-included-in-plan">
      <Heading type={includedData.includedHeadingType} html={includedData.includedHeadingBody} typographyClass="type-h3" />
      <BodyText className={"membership-included-in-plan-body"} html={includedData.includedBody} />
      <div className="membership-included-in-plan-checks">
        <BodyText html={includedData.includedListBody} />
      </div>
      <Heading type={includedData.includedListHeadingType} html={includedData.includedListHeadingBody} typographyClass="type-h4" />

      <div className="membership-included-in-plan-links">
        {(includedData?.includedLinks || []).map((item, index) => {
          return <PrimaryLink {...item?.fields} key={index} />;
        })}
      </div>

      {carWarrantyFields && (
        <div className="car-warranty-link">
          <PrimaryLink buttonText={carWarrantyFields?.buttonText?.value} colorScheme={carWarrantyFields.colorScheme} iconName={carWarrantyFields.iconName} callback={() => setShowCarWarrantyModalModal(true)} />
        </div>
      )}

      <Modal showModal={showCarWarrantyModal} onCloseClicked={() => setShowCarWarrantyModalModal(false)}>
        <div className="car-warranty">
          <h1>{carWarranty?.title}</h1>
          <div dangerouslySetInnerHTML={{ __html: carWarranty?.html }} />
          <div className="car-warranty-button">
            <PrimaryButton {...carWarrantyFields} buttonText={carWarrantyFields?.buttonText?.value} callback={() => setShowCarWarrantyModalModal(false)} />
          </div>
        </div>
      </Modal>

      {releaseNotesFields && (
        <div className="release-notes-link">
          <PrimaryLink buttonText={releaseNotesFields.buttonText.value} colorScheme={releaseNotesFields.colorScheme} iconName={releaseNotesFields.iconName} callback={() => setShowReleaseNotesModal(true)} />
        </div>
      )}

      <Modal showModal={showReleaseNotesModal} onCloseClicked={() => setShowReleaseNotesModal(false)}>
        <div className="release-notes">
          <h1>{releaseNotes?.title}</h1>
          <div dangerouslySetInnerHTML={{ __html: releaseNotes?.html }} />
        </div>
      </Modal>
    </div>
  );
};

MembershipIncludedInPlan.propTypes = {
  includedData: PropTypes.shape({
    includedHeadingType: PropTypes.object,
    includedHeadingBody: PropTypes.object,
    includedBody: PropTypes.object,
    includedListBody: PropTypes.object,
    includedListHeadingType: PropTypes.object,
    includedListHeadingBody: PropTypes.object,
    includedLinks: PropTypes.array
  })
};

export default MembershipIncludedInPlan;
